// yjjMixin.js
import moment from 'moment';
import RatePlate from 'components/plate/RatePlate.vue'
import RateRangePlate from 'components/plate/RateRangePlate.vue'

import PlateStockPopular from 'components/plate/PlateStockPopular.vue'
import PlateStockPopularTable from 'components/plate/PlateStockPopularTable.vue'
import StockMultiChart from 'components/stock/StockMultiChart.vue'
import StockKlineDay from 'components/stock/StockKlineDay.vue'
import StockInfoSidebar from 'components/stock/StockInfoSidebar.vue'

import {
	request_zzquant
} from "network/request.js"

export default {
	data() {
		return {
			selectedPlateCode: "",
			selectedPlateName: "",
			days: [],
			dayn: 10,
			symbol_name: "",
			symbol_code: null,
			selectedDate: null,
			date_mark: null,
		};
	},
	created() {
		const days_n = this.$route.params.dayn || 10 // 如果 URL 参数 dayn 不存在，使用 '10' 作为默认值
		this.dayn = days_n
	},
	mounted() {
		this.get_trade_days();
	},
	components: {
		RatePlate,
		RateRangePlate,
		PlateStockPopular,
		PlateStockPopularTable,
		StockMultiChart,
		StockKlineDay,
		StockInfoSidebar,
	},
	methods: {
		handleDateSelected(newDate) {
			this.selectedDate = newDate; // Update selectedDate when the date-selected event is emitted
		},
		handlePlateSelected(plateCode, plateName) {
			// 处理选中的板块
			// console.log(plateCode, plateName)
			this.selectedPlateCode = plateCode
			this.selectedPlateName = plateName
		},
		handleShowKline(symbol_code, symbol_name) {
			this.symbol_code = symbol_code
			this.symbol_name = symbol_name
			// console.log(symbol_code)
		},
		get_trade_days() {
			const now = moment();
			const currentTime = now.format('HH:mm');
			let currentDate = now.format('YYYY-MM-DD');					
			if (currentTime >= '09:31'){
				currentDate = now.add(1, 'days').format('YYYY-MM-DD');
			}
			const today = currentDate;
			request_zzquant({
					url: '/market/trade/days?day_end=' + today + '&days='+this.dayn
				})
				.then(res1 => {
					// console.log(res1['data']['data']);
					this.days = res1['data']['data'].slice().reverse();
					this.selectedDate = this.days[1]
				})
				.catch(err => {
					console.log(err);
				});
		}
	}
}
